module.exports = __webpack_public_path__ + "img/platforms.934a237c.png";